import React from "react";
import Books from "../components/Books/Books";

const Home = () => {
  return (
    <div>
      <Books />
    </div>
  );
};

export default Home;
